<template>
  <section style="background-color: #FFFFFF;">
    <div class="blue-nav-bar bg--blue padding-vertical-2x font-color-white align-right">
      <ul class="align-center">
        <li><a href="/about/volunteer/submit-opportunity" class="btn btn-outline">Post a Volunteer Opportunity</a></li>
      </ul>
    </div>

    <container class="padding-top-4x">
      <div class="row align-center" data-test="6-14">
        <h1>Get involved in your community</h1>
        <p>At Festival Foods, we know being involved in the communities we serve is important in being a good neighbor. Looking to volunteer? We’re all about connecting you with inspiring opportunities to give back to your community. Let’s make a difference together.</p>
      </div>
      <volunteer-opportunities-list></volunteer-opportunities-list>
    </container>

    <container class="padding-vertical-6x">
      <div class="align-center">
        <div class="margin-bottom-1x">
          <icon name="MagnifyingGlass" class="font-size-40" color="#aaa" />
        </div>
        <h2 class="font-size-28 normal-case semi-bold">Can't find the volunteer opportunity you're looking for?</h2>
        <p class="font-size-14">View additional opportunities in your area that are listed on VolunteerMatch</p>
      </div>
      <iframe id="volunteer-match-widget" style="width: 336px" frameborder="0" scrolling="no" height="280" src="https://www.volunteermatch.org/embed/search_widget_2.0_covid_336x280.jsp"></iframe>
    </container>

    <div class="blue-nav-bar bg--blue padding-vertical-2x font-color-white align-right">
      <ul class="align-center">
        <li><a href="https://assethealth.com/festfoods" @click="newWindow($event)">Be Well Login</a></li>
        <li><a href="https://festfoods.axonify.com/training/auth.html" @click="newWindow($event)">The Hub Login</a></li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Volunteer',
  metaInfo: {
    title: 'Volunteer Opportunities | Festival Foods',
    meta: [
      {
        name: 'description',
        content: "We're all about connecting you with inspiring opportunities to give back to your community."
      },
      {
        property: 'og:title',
        content: 'Volunteer Opportunities | Festival Foods'
      },
      {
        property: 'og:description',
        content: "We're all about connecting you with inspiring opportunities to give back to your community."
      },
      {
        property: 'og:image',
        content: 'https://storage.googleapis.com/assets.festfoods.com/images/about/community-involvement/volunteer-open-graph-image.jpg'
      }
    ]
  },
  components: {
    'volunteer-opportunities-list': () => import('@/components/volunteer/OpportunityList')
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
/**
* Blue bar
**/
.blue-nav-bar {
  ul {
    list-style: none;
    padding-left: none;

    @media(max-width:745px) {
      padding-left: 0;
    }

    li {
      display: inline-block;

      a {
        border-left: 1px solid rgba(255, 255, 255, 0.25);
        color: #FFFFFF;
        display: inline-block;
        padding: 25px;
        text-decoration: none;
        -webkit-transition: background-color 0.5s; /* Safari prior 6.1 */
        transition: background-color 0.5s;

        &:hover {
          background-color: rgba(255, 255, 255, 0.25);
        }
      }

      &:nth-child(1) a {
        border-right: 1px solid rgba(255, 255, 255, 0.25);
      }

      &:first-child {

        @media(max-width:745px) {
          width: 100%;
        }

        a {
          border: none;

        }
      }

      a.btn-outline {
        background: transparent;
        border: 1px solid #FFFFFF;
        font-size: 1.5rem;
        margin-right: 30px;
        padding: 15px;

        @media(max-width:745px) {
          margin-right: 0;
          margin-top: 15px;
        }

        &:hover {
          background-color: rgba(255, 255, 255, 0.25);
        }
      }
    }
  }
}
#volunteer-match-widget {
  display: block;
  margin: 20px auto auto auto;
}
</style>
